import { React, useState } from "react";
import { BsPlus, BsCartFill, BsHeart, BsFillHeartFill} from "react-icons/bs";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Sheet from 'react-modal-sheet';
import Product3 from "./Product3";
import {alert, confirm} from "../components/MegConfirmAlert";
import { useAxios } from "../services/useAxios";
import ProdList from "../components/ProdList";
import { useTranslation } from 'react-i18next';

export default function Product2 (props){
    const { t } = useTranslation();
    const [request] = useAxios();
    const location = useLocation();
    const navigate = useNavigate();  
    const [isOpen, setOpen] = useState(false);
    const [heart, setHeart] = useState(props.obj && props.obj.likeAt && props.obj.likeAt === 'Y');
    const handleHeart = async () => {
        const userData = localStorage.getItem("user");
        if (userData === null) {
            ConfirmPick();
            return;
        }else{
            const response = await request.post("/app/wishlist/procMyWishListAPI", {
                likeAt : heart?"N":"Y",
                goodsSn : props.obj.goodsSn,
                likeSn : props.obj.likeSn,
            });
            if(response.data.resultCode === 200){                                
                setHeart(!heart);
                if(props.setPickData){
                    props.setPickData()
                }
            }
        }
        
    }

    const ConfirmAlrm = async () => {
        const userData = localStorage.getItem("user");
        if (userData === null) {            
            navigate('/LogIn', {
                state: { from: location },
            })            
        }
        const result = await confirm('상품이 입고되면 알림톡으로 알려드립니다.\n재입고 알림을 받으시겠습니까?', {okText : '재입고 신청' , cancelText : t(`Message.common_no`)});
        if(result){
            alert(t(`Message.goods_fetch_restocking_req_sucss`), {okButtonStyle : 'secondary'}, {okText : t(`Message.common_ok`)});    
        }
    }

    const ConfirmPick = async () => {
        const result = await confirm(t(`Message.common_login_page_msg1`) + t(`Message.common_login_page_msg2`), {okText : t(`Message.common_yes`) , cancelText :t(`Message.common_no`)});
        if(result){
            navigate('/LogIn', {
                state: { from: location },
              })
        }
    }


    if (props.type==='type4') {
        return(
            <div className="prodType4">
                <div className="imgWr">
                    <img src={props.img} alt="상품" />
                </div>
                <ul className="infoWr">
                    <li className="dfColG4">
                        <p className="prodName">{props.prodName}</p>
                        <div className="dfcsG8">
                            <p className="option">{props.option}</p>                           
                        </div>
                    </li>                                    
                    <li>
                        <div className="dfcsG8">
                            <p className="disprice">{props.disprice}</p>
                            <p className="cost">{props.cost}</p>
                            <p className="percent">{props.percent}</p>
                        </div>
                       
                    </li>
                </ul>
            </div>
        );
    }else if (props.type==='type5') {
        return(
            <div>
                <Link to={"/ProductDetail/"+props.obj.goodsSn} className="prodType5">
                    <div className="imgWr">
                        <img src={props.img} alt="상품명" />
                    </div>

                    <ul className="infoWr">
                        <li>
                            <p className="prodName">{props.prodName}</p>
                            <div className="dfcsG8">
                                <p className="cost">{props.cost}</p>                               
                            </div>
                        </li>
                        <li>
                            <p className="disprice">{props.disprice}</p>
                        </li>
                    </ul>

                    <div className="btnWr">
                        <button 
                            type="button" 
                            className="heart"
                            onClick={(e) => {
                                e.preventDefault(); 
                                e.stopPropagation(); 
                                handleHeart();                                
                            }}>
                                { heart ? (<BsFillHeartFill className="active"/>) : (<BsHeart />)}
                        </button>
                        <button
                            className="openCartModal" 
                            onClick={(e) => {
                                e.preventDefault(); 
                                e.stopPropagation(); 
                                setOpen(true);
                            }}
                        >
                            <BsPlus />
                        </button>
                    </div>
                </Link>


                <ProdList id={props.obj.goodsSn} prodOpen={isOpen} setProdOpen={setOpen}></ProdList>
            </div>
        )
    } else if (props.type==='type6') {
        return (
            <div className="prodType6">
<               div className="imgWr">
                    <img src={props.img} alt="상품명" />
                </div>
                <div className="infoWr">
                    <p className="prodName">{props.prodName}</p>
                    <p className="optionWr">
                        <span className="option">{props.option1}</span>
                        <span className="option">{props.option2}</span>
                    </p>
                    <p className="disprice">{props.disprice}</p>
                </div>
            </div>
        )
    }
};